// export const urlLogin = "http://www.dreamchimney.com/tracks/login";
// const base = process.env.NODE_ENV === "production" ? `http://www.dreamchimney.com` : `http://www.dc.local`;
import { getAuthHeader } from "~/utils/headers";

const base = ``;

// uses php api
export const urlPasswordForgot = base + "/forgot";
export const urlPasswordReset = base + "/reset";
export const urlGetUser = base + "/api/tracks/user";
export const urlUploadAvatar = base + "/api/tracks/user/avatar";
export const urlUserApply = base + "/api/tracks/apply";
// php version
export const urlUserValidate = base + "/api/user/validate";
export const urlUserProfile = base + "/profile";
// export const urlUserProfileEditRead = base + "/profile/edit";
export const urlUserFavorites = base + "/favorites";
export const urlUserSocial = base + "/social";
// node express version, not used yet
// export const urlUserValidate = base + "/validate";

export const userValidate = (axios, urlUserValidate, vals) => axios.post(`${urlUserValidate}`, vals);
export const userPasswordForgot = (axios, vals) => axios.post(`${urlPasswordForgot}`, vals);
export const userPasswordReset = (axios, vals) => axios.post(`${urlPasswordReset}`, vals);
export const getUser = (axios, urlGetUser, vals) => axios.post(`${urlGetUser}`, vals);
export const postUserApplication = (axios, vals) => axios.post(`${urlUserApply}`, vals);

export const getUserProfile = (axios, userDir) => axios.get(`${urlUserProfile}?userDir=${userDir}`);
export const postGetUserFavorites = (axios, userDir, page = 1) => axios.post(`${urlUserFavorites}?userDir=${userDir}`, { userDir, page });
export const postAvatarUpload = (axios, formData) =>
  axios.post(`${urlUploadAvatar}`, formData, {
    headers: { "content-type": "multipart/form-data" },
  });

export const postUserSocialSave = (axios, payload) => axios.post(`${urlUserSocial}`, payload, getAuthHeader());
// export const getUserProfileEdit = (axios, payload) => axios.post(`${urlUserProfileEditRead}`, payload);
